import { useEffect } from 'react';

export const useKeyboardShortcuts = ({
  onUndo,
  onRedo,
  onDuplicate,
  onDelete,
  onSpacePress,
  onSpaceRelease,
  selectedNodeIds = [],
  selectedPrefabId = null,
  activeSidebarTab = 'components'
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore if typing in input/textarea
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }

      // Undo/Redo
      if ((e.metaKey || e.ctrlKey) && !e.shiftKey && e.key === 'z') {
        e.preventDefault();
        onUndo?.();
      } else if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'z') {
        e.preventDefault();
        onRedo?.();
      }

      // Space for panning
      if (e.code === 'Space') {
        e.preventDefault();
        if (!e.repeat) {
          onSpacePress?.();
        }
      }

      // Duplicate
      if ((e.metaKey || e.ctrlKey) && e.key === 'd') {
        e.preventDefault();
        onDuplicate?.();
      }

      // Delete
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (selectedNodeIds.length > 0) {
          e.preventDefault();
          onDelete?.(selectedNodeIds);
        } else if (selectedPrefabId && activeSidebarTab === 'prefabs') {
          e.preventDefault();
          onDelete?.([selectedPrefabId], true); // true = deletePrefab
        }
      }
    };

    const handleKeyUp = (e) => {
      if (e.code === 'Space') {
        onSpaceRelease?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [
    onUndo,
    onRedo,
    onDuplicate,
    onDelete,
    onSpacePress,
    onSpaceRelease,
    selectedNodeIds,
    selectedPrefabId,
    activeSidebarTab
  ]);
};
